import React, { useEffect } from 'react';
import styled from 'styled-components/macro';
import { useDrop } from 'react-dnd';
import { dndConstants } from '../../../store/constants';
import { useDispatch } from 'react-redux';
import { fileSelectedActions } from '../../../store/actions';
import { ApiAttachmentForFS } from '../../../store/models/MainFiles';

interface AttachmentListWrapperProps {
  isSelectAll: boolean;
}

const AttachmentListWrapper: React.FC<AttachmentListWrapperProps> = ({
  children,
  isSelectAll,
}) => {
  const dispatch = useDispatch();

  const [{ isOver }, drop] = useDrop({
    accept: [dndConstants.SRC_FILE, dndConstants.SRC_PAGE],
    drop: (
      item: {
        type: string;
        payload: { srcFile: ApiAttachmentForFS; pageNum?: number };
      },
      monitor,
    ) => {
      const { payload } = item;
      if (!payload.srcFile) throw Error(`missing payload.srcFile`);
      if (
        item.type === dndConstants.SRC_FILE ||
        item.type === dndConstants.SRC_PAGE
      ) {
        dispatch(
          fileSelectedActions.appendSrcFile(
            item.payload.srcFile,
            isSelectAll,
            item.payload.pageNum,
          ),
        );
      }
    },
    // canDrop: () => true,
    collect: (monitor) => ({
      isOver: !!monitor.isOver(),
      // canDrop: !!monitor.canDrop()
    }),
  });
  useEffect(() => {
    console.debug({ isOver });
  }, [isOver]);
  return (
    <SAttachmentsList>
      {children}
      <div ref={drop}>
        <SDragFileHere>
          Drag file here to create attachment
        </SDragFileHere>
        {isOver && (
          // might not need the classname
          <SHighlight className={`${isOver ? 'is-over' : ''} `} />
        )}
      </div>
    </SAttachmentsList>
  );
};

export default AttachmentListWrapper;

const SHighlight = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  background: ${(props) => props.theme.palette.highlight.transPink};
`;
const SAttachmentsList = styled.div`
  min-height: 10vh;
  &.is-over {
  }
  position: relative;

  & > * + *:not(${SHighlight}) {
    margin-top: 0.5rem;
  }
`;
const SDragFileHere = styled.div`
  height: 10vh;
  border-radius: 4px;
  border: dashed 2px ${(props) => props.theme.palette.primary.main};
  background: ${(props) => props.theme.palette.highlight.transPink};
  display: grid;
  place-items: center;
  margin-top: 1rem;
`;
